import React from 'react';
import './SelectPayComponent.scss';
import {setStorageCache, showLogin} from "../../asstes/js/Utils";
import {clearUserInfo, paySubmitOrder, showTipsAlert, showToast} from "../../asstes/js/IntegratedProcessing";
import Config from "../../asstes/js/Config";

class SelectPayComponent extends React.Component {
	state = {
		selectIdx: 0,
		selectMouseIdx: Config.selectMouse, // 当前选择的老鼠
		initBg: false,
		topImg: false
	}

	submit = (e) => {
		e.preventDefault()
		let {payInfo} = this.props
		let {selectIdx} = this.state
		let productInfo = payInfo.actionObjectList[selectIdx]
		paySubmitOrder(productInfo).then(res => {
			// console.log(res);
			if (res.success) {
				console.log(res.datas);
				setStorageCache('submitOrderInfo', res.datas, true)
				let {payStr} = res.datas
				window.location.href = payStr
			} else if (res.errorCode === '5104') {
				this.close()
				showTipsAlert('本活动仅限广东非深圳用户参与哦～', '我知道了')
			} else if (res.errorCode === '5105') { // 查询中行接口失败,请稍后再试
				showTipsAlert('当前参与的用户过多，请稍后再来吧～', '我知道了')
			} else if (res.errorCode === '600') { // 用户校验失败
				clearUserInfo()
				showLogin()
			} else {
				this.close()
				showToast('提交订单失败，请稍后重试！')
			}
		})
	}

	close = () => {
		this.props.closePayAlert && this.props.closePayAlert()
	}

	changeIdx = (idx) => {
		this.setState({
			selectIdx: idx
		})
	}

	initBg = () => {
		this.setState({
			initBg: true
		})
	}

	topImg = () => {
		this.setState({
			topImg: true
		})
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const payBtn = require('../../asstes/img/alert/pay-btn.png')
		const PayClose = require('../../asstes/img/alert/login-close.png')
		const selectBg = require('../../asstes/img/alert/select-bg.png')
		const selectArrow = require('../../asstes/img/alert/select-arrow-icon.png')
		let {payInfo} = this.props
		let {selectIdx, selectMouseIdx, initBg, topImg} = this.state
		const loginTopArr = [
			require('../../asstes/img/Index/gift-list/login-top1.png'),
			require('../../asstes/img/Index/gift-list/login-top2.png'),
			require('../../asstes/img/Index/gift-list/login-top3.png'),
			require('../../asstes/img/Index/gift-list/login-top4.png'),
			require('../../asstes/img/Index/gift-list/login-top5.png'),
			require('../../asstes/img/Index/gift-list/login-top6.png'),
		]

		const selectBgStyle = {
			background: `url(${selectBg})`,
			backgroundSize: '100% 100%',
		}

		return <div className="select-pay-container">
			<p className="prompt"></p>
			<div className="pay-relative">
				<img src={loginBg} onLoad={this.initBg} alt=""/>
				{
					initBg ?
						<>
							<div className="pay-container-content">
								<img className="relative-img" src={loginTopArr[selectMouseIdx]} onLoad={this.topImg} alt=""/>
								{
									topImg ?
										<>
											<div className="pay-top-text">
												请选择您要支付的金额，就能打开锦盒了，惊喜好礼藏在里面哦!
											</div>
											<div className="pay-list flex-center-center">
												{
													payInfo.actionObjectList.map((item, idx) => {
														return <div className={`pay-list-item ${idx === selectIdx ? 'active' : ''}`}
														            style={idx === selectIdx ? selectBgStyle : {}}
														            key={idx}
														            onClick={() => this.changeIdx(idx)}>
															{item.sellingPrice}<span className="pay-item-yuan">元</span>
															{
																idx !== selectIdx ? null :
																	<img className="select-arrow" src={selectArrow} alt=""/>
															}
														</div>
													})
												}
											</div>
											<div className="pay-bottom-text">
												<p>
													说明：您支付的金额在活动结束后将统一捐赠给广东省少年发展基金会，感谢您的爱心捐款。
												</p>
												<p style={{color: '#fff'}}>
													PS：爱心越大，运气可能越好哦！
												</p>
											</div>
											<div className="pay-btn">
												<a href="/" onClick={this.submit}>
													<img src={payBtn} alt=""/>
												</a>
											</div>
										</> : null
								}
							</div>
							<div className="login-close flex-center-center">
								<img className="login-close-icon" src={PayClose} onClick={this.close} alt=""/>
							</div>
						</> : null
				}
			</div>
		</div>
	}
}

export default SelectPayComponent;
